import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    wrapper: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: "1.5rem",
        justifyContent: "center",
        height: "100%",
        padding: "1.25rem 1.5rem",
    },
    iconWrapper: {
        alignItems: "center",
        backgroundColor: theme.colors.violet[1],
        borderRadius: "2rem",
        display: "flex",
        justifyContent: "center",
        width: "4rem",
        height: "4rem",
    },
    icon: {
        width: "1.5rem",
        height: "1.5rem",
    },
    content: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: ".5rem",
        textAlign: "center",
    },
    heading: {
        color: theme.colors.gray[9],
        fontSize: "1.125rem",
        fontWeight: 500,
        lineHeight: 1.45,
        margin: 0,
    },
    description: {
        color: theme.colors.gray[7],
        fontSize: ".875rem",
        lineHeight: 1.5,
        margin: 0,
    },
}))
